/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ScvAttribute } from './ScvAttribute.defs';
import { SCV_ATTRIBUTE_PRIMARY_EMAIL } from './ScvSystemAttributes.constants';

/**
 * Country code.
 * @export
 */
export const SCV_ATTRIBUTE_COUNTRY_CODE: ScvAttribute = {
  key: `countryCode`,
  title: `Country code`,
  type: `string`,
};

/**
 * Region.
 * @export
 */
export const SCV_ATTRIBUTE_REGION: ScvAttribute = {
  key: `region`,
  title: `Region`,
  type: `string`,
};

/**
 * All SCV basic attributes.
 * @export
 */
export const SCV_BASIC_ATTRIBUTES: Array<ScvAttribute> = [
  SCV_ATTRIBUTE_PRIMARY_EMAIL,
  SCV_ATTRIBUTE_COUNTRY_CODE,
  SCV_ATTRIBUTE_REGION,
];
